import { forwardRef } from 'react';
import {
  type ChatInputHandle,
  ChatInput as SharedChatInput,
} from '@/features/ai-chat/ui/ChatInput';
import { TokenLimitExceededView } from '@/features/ai-chat/ui/TokenLimitExceededView';
import { getSessionStorage } from '@/shared/lib/storage';
import { Card } from '@/shared/ui';

type Props = {
  onSend: (message: string) => void;
  /** AI応答待ち中。入力は可能だが送信は不可 */
  waiting?: boolean;
  /** プレースホルダ（Welcome / Thread で文言を出し分けるため） */
  placeholder?: string;
  /** トークン上限超過時。入力欄をエラー表示に差し替える */
  isTokenLimitExceeded?: boolean;
};

/**
 * 事業チャットの入力欄。
 * 共通 ChatInput の embedded レイアウトを利用しつつ、トークン上限・デバッグモード時は
 * TokenLimitExceededView に差し替える（汎用チャット GeneralChatInput と同様のパターン）。
 */
export const ChatInput = forwardRef<ChatInputHandle, Props>(
  ({ onSend, waiting = false, placeholder, isTokenLimitExceeded }, ref) => {
    const isDebugAITokenErrorMode = getSessionStorage('debug-ai-token-error-mode');

    // デバッグメニューの「AIトークンエラーモード」が ON のときは
    // 実 API 呼び出しを介さずに TokenLimitExceededView を表示する
    if (isDebugAITokenErrorMode || isTokenLimitExceeded) {
      return (
        <Card className="flex max-h-60 min-h-28 flex-col justify-center gap-2 p-2 shadow-xs focus-within:ring-2 focus-within:ring-focus-ring">
          <TokenLimitExceededView />
        </Card>
      );
    }

    return (
      <SharedChatInput ref={ref} onSend={onSend} waiting={waiting} placeholder={placeholder} />
    );
  },
);

ChatInput.displayName = 'ChatInput';
